<app-loader></app-loader>
<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
            
            <div class="card card-login p-4 shadow">
                <div class="card-body">
                    
                    <div class="text-center mb-4">
                        <div class="logotipo-seccion">
                            <span class="icono-bolsa pointer"><i class="fa-solid fa-bag-shopping"></i></span>
                            <h1 class="nombre-app pointer">Colpraz!</h1>
                        </div>
                    </div>

                    <form action="procesar_login.php" method="POST">
                        
                        <div class="mb-3">
                            <label for="email" class="form-label fw-semibold">Correo Electrónico</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light"><i class="fa-regular fa-envelope"></i></span>
                                <input type="email" class="form-control" id="email" name="email" placeholder="nombre@ejemplo.com" required autocomplete="email"
                                  [(ngModel)]="formData.username">
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="d-flex justify-content-between">
                                <label for="password" class="form-label fw-semibold">Contraseña</label>
                                <a href="#" class="text-decoration-none small text-muted">¿La olvidaste?</a>
                            </div>
                            <div class="input-group">
                                <span class="input-group-text bg-light"><i class="fa-solid fa-lock"></i></span>
                                <input type="password" class="form-control" id="password" name="password" placeholder="••••••••" required autocomplete="current-password"
                                  [(ngModel)]="formData.password">
                            </div>
                        </div>

                        <div class="d-grid text-danger fw-bold mb-3" *ngIf="error">
                          {{error}}
                        </div>

                        <div class="d-grid">
                            <button type="submit" class="boton-accion" (click)="login()">
                                Entrar
                            </button>
                        </div>
                    </form>

                    <div class="text-center mt-4 pt-2 border-top">
                        <p class="mb-0 text-muted small">¿No tienes cuenta? <a href="#" class="text-primary fw-semibold text-decoration-none">Regístrate aquí</a></p>
                    </div>

                </div>
            </div>
            </div>
    </div>
</div>